// React
import { Fragment } from "react"

// Components
import { ApproveAction } from "./ApproveAction"

// Icons
// Third-Party Libraries
import moment from "moment"

// Utils
import { statusMap } from "../utils"
import { convertNumber } from "utils"
import { TableNumber } from "components"

export function Item(props: {
    data: any,
    index: number
    refetch: () => void,
    pagination: any
}) {
   
    return (
        <Fragment>
            <tr key={props.index}>
                <td>{TableNumber({ dataLength: props.pagination.limit, pageCurrent: props.pagination.page, index: props.index, limit: props.pagination.limit, totalData: props.pagination.total })}</td>
                <td>
                    <ApproveAction data={props.data} refetch={props.refetch} />
                </td>
                <td>{props.data.trx_code}</td>
                <td>{props.data.transaction_date ? moment(props.data.transaction_date).format("DD/MM/YYYY") : ""}</td>
                <td>{props.data.type_received === 1 ? "Received Item" : (props.data.type_rejected === 2 ? "Received Money" : "Adjustment AP")}</td>
                <td>{props.data.vendor_name}</td>
                <td>{props.data.reject_trx_code}</td>
                <td>{props.data.location_name}</td>
                <td>{props.data.memo}</td>
                <td className="text-center">{props.data.qty ? convertNumber(props.data.qty).intoNormalAmount : ""}</td>
                <td>{statusMap[props.data.approve_status]}</td>
                <td>{props.data.approve_date ? moment(props.data.approve_date).format("DD/MM/YYYY") : ""}</td>
            </tr>
        </Fragment>
    )
}